var React = require('react');

function IconSmArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fill":"#9e9e9e","d":"M16.59 8.59L12 12.917 7.41 8.59 6 9.922l6 5.668 6-5.668z","transform":"translate(-6 -8.59)"})));
}

IconSmArrowDown.defaultProps = {"width":"12","height":"7","viewBox":"0 0 12 7"};

module.exports = IconSmArrowDown;

IconSmArrowDown.default = IconSmArrowDown;
